import { AnyAction } from 'redux';
import { GlobalAction, GlobalActions } from '@ps20-frontend/shop-integration-redux';
import {
  EinstiegResponse,
  PersonensuchePersonenart,
  PersonensucheResponse,
} from '@ps20/bff-models';
import { convertDate } from '@ps20-frontend/utils';
import { IAppState } from '../appState';

export const unfallPersonenReducer = function (
  sectionState: IAppState['unfallPersonen'] = [],
  action: AnyAction,
): IAppState['unfallPersonen'] {
  switch (action.type) {
    case GlobalActions.EINSTIEG_REQUEST_SUCCESSFUL:
      return loadVnAsDefault(sectionState, action);
    case GlobalActions.AMIS_CRM_PERSONENGRUPPE_REQUEST_SUCCESSFUL:
      return loadGruppe(sectionState, action);
    default:
      return sectionState;
  }
};

function loadVnAsDefault(
  sectionState: IAppState['unfallPersonen'],
  action: AnyAction,
): IAppState['unfallPersonen'] {
  const vn = (action as GlobalAction<EinstiegResponse>).payload.versicherungsnehmer;
  if (vn) {
    const personenart = vn.juristisch
      ? PersonensuchePersonenart.JURISTISCHE_PERSON
      : PersonensuchePersonenart.NATUERLICHE_PERSON;
    const vnData = { ...vn };
    delete vnData.juristisch;

    return [
      {
        ...vnData,
        datenVollstaendig: true,
        personenart,
        geburtsdatum: vn.geburtsdatum ? convertDate(vn.geburtsdatum) : null,
      },
    ];
  }
  return sectionState;
}

function loadGruppe(
  sectionState: IAppState['unfallPersonen'],
  action: AnyAction,
): IAppState['unfallPersonen'] {
  const personen = (action as GlobalAction<PersonensucheResponse>).payload.personen;
  return personen.map(person => ({
    ...person,
    geburtsdatum: person.geburtsdatum ? convertDate(person.geburtsdatum) : null,
  }));
}
